import React from "react";
import { Accordion } from "devextreme-react";
import SiniestroItem from "./siniestro";
import { dateFormat } from "../Planes/functions";

class AccordionSiniestros extends React.PureComponent {
  render() {
    return (
      <Accordion
        dataSource={this.props.items}
        defaultSelectedIndex={null}
        collapsible
        itemTitleComponent={(data) => (
          <div className="row" style={{ margin: 0, marginTop: 5 }}>
            <div className="col-sm-4 PM-informativo text-left">
              <span>Trabajador</span>
              <p>{data.nombreTrabajador}</p>
            </div>
            <div className="col-sm-2 PM-informativo text-left">
              <span>RUT</span>
              <p>{data.ruttrabajador}</p>
            </div>
            <div className="col-sm-2 PM-informativo text-left">
              <span>Siniestro</span>
              <p>Trayecto {data.idsiniestro}</p>
            </div>
            <div className="col-sm-2 PM-informativo text-left">
              <span>Fecha presentación</span>
              <p>{dateFormat(data.fpresentacion)}</p>
            </div>
            <div className="col-sm-2 PM-informativo text-left">
              <span>Fecha siniestro</span>
              <p>{dateFormat(data.fsiniestro)}</p>
            </div>
          </div>
        )}
        itemComponent={(data) => <SiniestroItem data={data} />}
      />
    );
  }
}

export default AccordionSiniestros;
